/* globals module, snowdome */

var $alerts = null;

module.exports = {
	init: function() {
		"use strict";

		$alerts = $('#alerts');
	},

	/**
	 * Show an error alert
	 * @param content - Alert content
	 * @param {String} content - Alert content
	 * @param {boolean} html - If true, content will be added using innerHTML
	 * @param {function} callback - If given, will add yes/no buttons that trigger the callback function.
	 * @returns {*|Element}
	 */
	showError: function(content, html, callback, title) {
		"use strict";

		var alert = this.createAlert('error', content, html, callback, title);

		$alerts.prepend(alert);
		$('body').addClass('alert-open');

		return alert;
	},

	/**
	 * Show an warning alert
	 * @param content - Alert content
	 * @param {String} content - Alert content
	 * @param {boolean} html - If true, content will be added using innerHTML
	 * @param {function} callback - If given, will add yes/no buttons that trigger the callback function.
	 * @returns {*|Element}
	 */
	showWarning: function(content, html, callback, title) {
		"use strict";

		var alert = this.createAlert('warning', content, html, callback, title);
		$alerts.prepend(alert);
		$('body').addClass('alert-open');

		return alert;
	},

	/**
	 * Show an success alert
	 * @param content - Alert content
	 * @param {String} content - Alert content
	 * @param {boolean} html - If true, content will be added using innerHTML
	 * @param {function} callback - If given, will add yes/no buttons that trigger the callback function.
	 * @returns {*|Element}
	 */
	showSuccess: function(content, html, callback, title) {
		"use strict";

		var alert = this.createAlert('warning', content, html, callback, title);
		$alerts.prepend(alert);
		$('body').addClass('alert-open');

		return alert;
	},

	/**
	 * Creates an alert
	 * @param {string} type - Type of alert (error, success, warning)
	 * @param {String} content - Alert content
	 * @param {boolean} html - If true, content will be added using innerHTML
	 * @param {function} callback - If given, will add yes/no buttons that trigger the callback function.
	 * @returns {Element} The alert element
	 */
	createAlert: function(type, content, html, callback, title) {
		"use strict";

		var that = this,
			alert = document.createElement('li'),
			close = null,
			p = document.createElement('p'),
			ok = null;

		alert.className = 'alert alert--' + type;
		alert.dataset.title = (typeof title !== 'undefined') ? title : 'Are you sure?';
		alert.appendChild(p);
		alert.open = true;

		if(html) {
			p.innerHTML = content;
		} else {
			p.innerText = content;
		}
		
		if(typeof callback === "function"){
			close = document.createElement('div');
			close.className = 'alert__options';
			close.innerHTML = '\
				<a href="#" class="alert__yes">Yes</a>\
				<a href="#" class="alert__no">No</a>\
			';
			$(close).one('click', '.alert__yes', function(e) {
				e.preventDefault();
				callback.call(alert, true);
				that.closeAlert(alert);
			});
			$(close).one('click', '.alert__no', function(e) {
				e.preventDefault();
				callback.call(alert, false);
				that.closeAlert(alert);
			});
		} else {
			ok = document.createElement('button');
			ok.className = 'btn btn--primary';
			ok.innerHTML = 'OK';
			$(ok).one('click', function(e) {
				that.closeAlert(alert);
			});
			alert.appendChild(ok);

			close = document.createElement('button');
			close.className = 'alert__close';
			close.innerHTML = '<svg xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="#icon--close-delete-x"></use></svg>';
			
			$(close).one('click', function() {
				that.closeAlert(alert);
			});
		}

		setTimeout(function() {
			that.closeAlert(alert);
		}, 10000);

		alert.appendChild(close);

		return alert;
	},

	/**
	 * Close an existing alert
	 * @param {Element} alert - The alert to close
	 */
	closeAlert: function(alert) {
		var parent = alert.parentNode;

		//TODO: Probably an animation here
		alert.open = false;
		$(alert).remove();

		if(!parent.querySelectorAll(".alert").length){
			$('body').removeClass('alert-open');
		}
	}
};
